import React from "react";
import {
  List,
  ListItem,
  Drawer,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Collapse,
} from "@mui/material";
import { Link, withRouter } from "react-router-dom";
import {
  NavLink as NavLinkBase,
  BrowserRouter as Router,
} from "react-router-dom";

import { SidebarData } from "./SidebarData";
import SidebarItem from "./SidebarItem";

const drawerWidth = 200;

const NavLink = React.forwardRef((props, ref) => (
  <NavLinkBase ref={ref} {...props} className={props.activeClassName} />
));

const Sidebar = () => {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <List>
        {/* {SidebarData.map((val, key) => {
          return (
            <ListItem key={key} disablePadding>
              <ListItemButton onClick={onclick(val.link)}>
                <ListItemText
                  primary={val.title}
                  primaryTypographyProps={{ fontSize: "12px" }}
                />
              </ListItemButton>
            </ListItem>
          );
        })} */}

        {SidebarData.map((val, key) => {
          return (
            <SidebarItem key={key} value={val} />

            /* <div key={key}>
              <Link to={val.link}> {val.title}</Link>
               <ListItem
                component={NavLink}
                key={key}
                disablePadding
                to={val.link}
              >
                <ListItemButton>
                  <ListItemText
                    primary={val.title}
                    primaryTypographyProps={{ fontSize: "12px" }}
                  />
                </ListItemButton>
              </ListItem>
            </div> */
          );
        })}
      </List>
    </Drawer>
  );
};
export default withRouter(Sidebar);
